import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import 'react-medium-image-zoom/dist/styles.css';
import 'url-search-params-polyfill';
import './main.css';
import './custom.css';
import './i18nextInstance';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import App from 'app';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';
import { RouterContainer } from 'views/containers';
import { ThemeProvider } from 'styled-components';
import { theme } from 'styled';
import { history, store } from './core/store.config';

ReactDOM.render(
    <Provider store={ store }>
        <ThemeProvider theme={ theme }>
            <App>
                <RouterContainer history={ history } />
            </App>
        </ThemeProvider>
    </Provider>,
    document.getElementById('root')
);

serviceWorkerRegistration.register({
    onUpdate: registration => {
        const waitingServiceWorker = registration.waiting;
        if (waitingServiceWorker) {
            waitingServiceWorker.addEventListener('statechange', event => {
                if (event.target.state === 'activated') {
                    window.location.reload(true);
                }
            });
            waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
        }
    }
});
